module.exports = __webpack_public_path__ + "img/Pyromaniac.09d5b0df.png";